"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.function.name.js");
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectDestructuringEmpty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _price = _interopRequireDefault(require("@gravity/price"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _product = require("@nucleo/product");
var _ProductActions = _interopRequireDefault(require("./ProductActions"));
var _ProductDate = _interopRequireDefault(require("./ProductDate"));
var _ProductImage = _interopRequireDefault(require("./ProductImage"));
var _jsxFileName = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine2.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17,
  _templateObject18,
  _templateObject19,
  _templateObject20,
  _templateObject21,
  _templateObject22,
  _templateObject23,
  _templateObject24,
  _templateObject25,
  _this = void 0;
function cov_190vs8imlh() {
  var path = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine2.js";
  var hash = "03fb6ab466befda8148c33387b1c0f1e598f936f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine2.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 16,
          column: 4
        }
      },
      "1": {
        start: {
          line: 18,
          column: 23
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "2": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 29,
          column: 13
        }
      },
      "3": {
        start: {
          line: 37,
          column: 13
        },
        end: {
          line: 37,
          column: 72
        }
      },
      "4": {
        start: {
          line: 46,
          column: 20
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "5": {
        start: {
          line: 55,
          column: 20
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "6": {
        start: {
          line: 74,
          column: 23
        },
        end: {
          line: 91,
          column: 1
        }
      },
      "7": {
        start: {
          line: 93,
          column: 27
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "8": {
        start: {
          line: 96,
          column: 31
        },
        end: {
          line: 96,
          column: 73
        }
      },
      "9": {
        start: {
          line: 104,
          column: 21
        },
        end: {
          line: 123,
          column: 1
        }
      },
      "10": {
        start: {
          line: 125,
          column: 23
        },
        end: {
          line: 145,
          column: 1
        }
      },
      "11": {
        start: {
          line: 147,
          column: 24
        },
        end: {
          line: 159,
          column: 1
        }
      },
      "12": {
        start: {
          line: 161,
          column: 24
        },
        end: {
          line: 184,
          column: 1
        }
      },
      "13": {
        start: {
          line: 176,
          column: 25
        },
        end: {
          line: 176,
          column: 36
        }
      },
      "14": {
        start: {
          line: 185,
          column: 26
        },
        end: {
          line: 203,
          column: 1
        }
      },
      "15": {
        start: {
          line: 205,
          column: 22
        },
        end: {
          line: 213,
          column: 1
        }
      },
      "16": {
        start: {
          line: 215,
          column: 29
        },
        end: {
          line: 245,
          column: 1
        }
      },
      "17": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 220,
          column: 35
        }
      },
      "18": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 223,
          column: 41
        }
      },
      "19": {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 239,
          column: 3
        }
      },
      "20": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 244,
          column: 3
        }
      },
      "21": {
        start: {
          line: 247,
          column: 26
        },
        end: {
          line: 265,
          column: 1
        }
      },
      "22": {
        start: {
          line: 254,
          column: 25
        },
        end: {
          line: 254,
          column: 36
        }
      },
      "23": {
        start: {
          line: 271,
          column: 21
        },
        end: {
          line: 373,
          column: 1
        }
      },
      "24": {
        start: {
          line: 288,
          column: 6
        },
        end: {
          line: 288,
          column: 11
        }
      },
      "25": {
        start: {
          line: 289,
          column: 21
        },
        end: {
          line: 289,
          column: 44
        }
      },
      "26": {
        start: {
          line: 291,
          column: 4
        },
        end: {
          line: 291,
          column: 84
        }
      },
      "27": {
        start: {
          line: 293,
          column: 2
        },
        end: {
          line: 297,
          column: 3
        }
      },
      "28": {
        start: {
          line: 294,
          column: 4
        },
        end: {
          line: 294,
          column: 46
        }
      },
      "29": {
        start: {
          line: 295,
          column: 9
        },
        end: {
          line: 297,
          column: 3
        }
      },
      "30": {
        start: {
          line: 296,
          column: 4
        },
        end: {
          line: 296,
          column: 43
        }
      },
      "31": {
        start: {
          line: 298,
          column: 25
        },
        end: {
          line: 298,
          column: 48
        }
      },
      "32": {
        start: {
          line: 299,
          column: 20
        },
        end: {
          line: 299,
          column: 58
        }
      },
      "33": {
        start: {
          line: 301,
          column: 4
        },
        end: {
          line: 302,
          column: 56
        }
      },
      "34": {
        start: {
          line: 303,
          column: 2
        },
        end: {
          line: 372,
          column: 4
        }
      },
      "35": {
        start: {
          line: 375,
          column: 0
        },
        end: {
          line: 436,
          column: 2
        }
      },
      "36": {
        start: {
          line: 438,
          column: 0
        },
        end: {
          line: 452,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 18
          },
          end: {
            line: 24,
            column: 19
          }
        },
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 29,
            column: 13
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        loc: {
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 37,
            column: 72
          }
        },
        line: 37
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 96,
            column: 22
          },
          end: {
            line: 96,
            column: 23
          }
        },
        loc: {
          start: {
            line: 96,
            column: 31
          },
          end: {
            line: 96,
            column: 73
          }
        },
        line: 96
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 176,
            column: 16
          },
          end: {
            line: 176,
            column: 17
          }
        },
        loc: {
          start: {
            line: 176,
            column: 25
          },
          end: {
            line: 176,
            column: 36
          }
        },
        line: 176
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 218,
            column: 22
          },
          end: {
            line: 218,
            column: 23
          }
        },
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 220,
            column: 35
          }
        },
        line: 219
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 221,
            column: 11
          },
          end: {
            line: 221,
            column: 12
          }
        },
        loc: {
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 223,
            column: 41
          }
        },
        line: 222
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        },
        loc: {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 239,
            column: 3
          }
        },
        line: 232
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 240,
            column: 4
          },
          end: {
            line: 240,
            column: 5
          }
        },
        loc: {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 244,
            column: 3
          }
        },
        line: 241
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 254,
            column: 16
          },
          end: {
            line: 254,
            column: 17
          }
        },
        loc: {
          start: {
            line: 254,
            column: 25
          },
          end: {
            line: 254,
            column: 36
          }
        },
        line: 254
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 271,
            column: 21
          },
          end: {
            line: 271,
            column: 22
          }
        },
        loc: {
          start: {
            line: 271,
            column: 39
          },
          end: {
            line: 373,
            column: 1
          }
        },
        line: 271
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 29,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 5
          },
          end: {
            line: 25,
            column: 10
          }
        }, {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 17
          }
        }, {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 34
          }
        }, {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 46
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 13
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 37,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 37,
            column: 31
          }
        }, {
          start: {
            line: 37,
            column: 35
          },
          end: {
            line: 37,
            column: 72
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 220,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 219,
            column: 5
          },
          end: {
            line: 219,
            column: 16
          }
        }, {
          start: {
            line: 219,
            column: 20
          },
          end: {
            line: 219,
            column: 41
          }
        }, {
          start: {
            line: 219,
            column: 45
          },
          end: {
            line: 219,
            column: 82
          }
        }, {
          start: {
            line: 220,
            column: 4
          },
          end: {
            line: 220,
            column: 35
          }
        }],
        line: 219
      },
      "3": {
        loc: {
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 223,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 5
          },
          end: {
            line: 222,
            column: 16
          }
        }, {
          start: {
            line: 222,
            column: 20
          },
          end: {
            line: 222,
            column: 41
          }
        }, {
          start: {
            line: 222,
            column: 45
          },
          end: {
            line: 222,
            column: 76
          }
        }, {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 223,
            column: 41
          }
        }],
        line: 222
      },
      "4": {
        loc: {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 239,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 232,
            column: 22
          }
        }, {
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 239,
            column: 3
          }
        }],
        line: 232
      },
      "5": {
        loc: {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 244,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 241,
            column: 22
          }
        }, {
          start: {
            line: 242,
            column: 4
          },
          end: {
            line: 244,
            column: 3
          }
        }],
        line: 241
      },
      "6": {
        loc: {
          start: {
            line: 289,
            column: 21
          },
          end: {
            line: 289,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 289,
            column: 21
          },
          end: {
            line: 289,
            column: 32
          }
        }, {
          start: {
            line: 289,
            column: 36
          },
          end: {
            line: 289,
            column: 44
          }
        }],
        line: 289
      },
      "7": {
        loc: {
          start: {
            line: 291,
            column: 4
          },
          end: {
            line: 291,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 291,
            column: 5
          },
          end: {
            line: 291,
            column: 16
          }
        }, {
          start: {
            line: 291,
            column: 20
          },
          end: {
            line: 291,
            column: 44
          }
        }, {
          start: {
            line: 291,
            column: 50
          },
          end: {
            line: 291,
            column: 58
          }
        }, {
          start: {
            line: 291,
            column: 62
          },
          end: {
            line: 291,
            column: 83
          }
        }],
        line: 291
      },
      "8": {
        loc: {
          start: {
            line: 293,
            column: 2
          },
          end: {
            line: 297,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 293,
            column: 2
          },
          end: {
            line: 297,
            column: 3
          }
        }, {
          start: {
            line: 295,
            column: 9
          },
          end: {
            line: 297,
            column: 3
          }
        }],
        line: 293
      },
      "9": {
        loc: {
          start: {
            line: 295,
            column: 9
          },
          end: {
            line: 297,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 295,
            column: 9
          },
          end: {
            line: 297,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 295
      },
      "10": {
        loc: {
          start: {
            line: 298,
            column: 25
          },
          end: {
            line: 298,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 298,
            column: 25
          },
          end: {
            line: 298,
            column: 36
          }
        }, {
          start: {
            line: 298,
            column: 40
          },
          end: {
            line: 298,
            column: 48
          }
        }],
        line: 298
      },
      "11": {
        loc: {
          start: {
            line: 299,
            column: 20
          },
          end: {
            line: 299,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 299,
            column: 20
          },
          end: {
            line: 299,
            column: 43
          }
        }, {
          start: {
            line: 299,
            column: 47
          },
          end: {
            line: 299,
            column: 58
          }
        }],
        line: 299
      },
      "12": {
        loc: {
          start: {
            line: 301,
            column: 4
          },
          end: {
            line: 302,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 301,
            column: 5
          },
          end: {
            line: 301,
            column: 16
          }
        }, {
          start: {
            line: 301,
            column: 20
          },
          end: {
            line: 301,
            column: 38
          }
        }, {
          start: {
            line: 301,
            column: 42
          },
          end: {
            line: 301,
            column: 64
          }
        }, {
          start: {
            line: 302,
            column: 5
          },
          end: {
            line: 302,
            column: 13
          }
        }, {
          start: {
            line: 302,
            column: 17
          },
          end: {
            line: 302,
            column: 32
          }
        }, {
          start: {
            line: 302,
            column: 36
          },
          end: {
            line: 302,
            column: 55
          }
        }],
        line: 301
      },
      "13": {
        loc: {
          start: {
            line: 305,
            column: 56
          },
          end: {
            line: 305,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 305,
            column: 56
          },
          end: {
            line: 305,
            column: 67
          }
        }, {
          start: {
            line: 305,
            column: 71
          },
          end: {
            line: 305,
            column: 87
          }
        }],
        line: 305
      },
      "14": {
        loc: {
          start: {
            line: 306,
            column: 9
          },
          end: {
            line: 306,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 306,
            column: 9
          },
          end: {
            line: 306,
            column: 18
          }
        }, {
          start: {
            line: 306,
            column: 22
          },
          end: {
            line: 306,
            column: 54
          }
        }],
        line: 306
      },
      "15": {
        loc: {
          start: {
            line: 307,
            column: 9
          },
          end: {
            line: 308,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 307,
            column: 9
          },
          end: {
            line: 307,
            column: 25
          }
        }, {
          start: {
            line: 308,
            column: 10
          },
          end: {
            line: 308,
            column: 33
          }
        }, {
          start: {
            line: 308,
            column: 37
          },
          end: {
            line: 308,
            column: 98
          }
        }],
        line: 307
      },
      "16": {
        loc: {
          start: {
            line: 310,
            column: 9
          },
          end: {
            line: 315,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 310,
            column: 9
          },
          end: {
            line: 310,
            column: 20
          }
        }, {
          start: {
            line: 311,
            column: 10
          },
          end: {
            line: 311,
            column: 26
          }
        }, {
          start: {
            line: 312,
            column: 12
          },
          end: {
            line: 314,
            column: 27
          }
        }],
        line: 310
      },
      "17": {
        loc: {
          start: {
            line: 318,
            column: 11
          },
          end: {
            line: 325,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 318,
            column: 11
          },
          end: {
            line: 318,
            column: 24
          }
        }, {
          start: {
            line: 319,
            column: 12
          },
          end: {
            line: 319,
            column: 36
          }
        }, {
          start: {
            line: 320,
            column: 12
          },
          end: {
            line: 320,
            column: 25
          }
        }, {
          start: {
            line: 321,
            column: 14
          },
          end: {
            line: 324,
            column: 37
          }
        }],
        line: 318
      },
      "18": {
        loc: {
          start: {
            line: 321,
            column: 50
          },
          end: {
            line: 321,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 321,
            column: 50
          },
          end: {
            line: 321,
            column: 63
          }
        }, {
          start: {
            line: 321,
            column: 67
          },
          end: {
            line: 321,
            column: 83
          }
        }],
        line: 321
      },
      "19": {
        loc: {
          start: {
            line: 327,
            column: 11
          },
          end: {
            line: 337,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 327,
            column: 11
          },
          end: {
            line: 327,
            column: 23
          }
        }, {
          start: {
            line: 328,
            column: 12
          },
          end: {
            line: 328,
            column: 28
          }
        }, {
          start: {
            line: 329,
            column: 14
          },
          end: {
            line: 336,
            column: 31
          }
        }],
        line: 327
      },
      "20": {
        loc: {
          start: {
            line: 339,
            column: 9
          },
          end: {
            line: 339,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 339,
            column: 9
          },
          end: {
            line: 339,
            column: 17
          }
        }, {
          start: {
            line: 339,
            column: 21
          },
          end: {
            line: 339,
            column: 36
          }
        }, {
          start: {
            line: 339,
            column: 40
          },
          end: {
            line: 339,
            column: 90
          }
        }],
        line: 339
      },
      "21": {
        loc: {
          start: {
            line: 341,
            column: 9
          },
          end: {
            line: 346,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 341,
            column: 9
          },
          end: {
            line: 341,
            column: 18
          }
        }, {
          start: {
            line: 342,
            column: 10
          },
          end: {
            line: 342,
            column: 26
          }
        }, {
          start: {
            line: 343,
            column: 12
          },
          end: {
            line: 345,
            column: 30
          }
        }],
        line: 341
      },
      "22": {
        loc: {
          start: {
            line: 348,
            column: 11
          },
          end: {
            line: 356,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 348,
            column: 11
          },
          end: {
            line: 348,
            column: 20
          }
        }, {
          start: {
            line: 349,
            column: 12
          },
          end: {
            line: 355,
            column: 30
          }
        }],
        line: 348
      },
      "23": {
        loc: {
          start: {
            line: 357,
            column: 11
          },
          end: {
            line: 362,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 357,
            column: 11
          },
          end: {
            line: 357,
            column: 22
          }
        }, {
          start: {
            line: 358,
            column: 12
          },
          end: {
            line: 358,
            column: 21
          }
        }, {
          start: {
            line: 359,
            column: 14
          },
          end: {
            line: 361,
            column: 34
          }
        }],
        line: 357
      },
      "24": {
        loc: {
          start: {
            line: 365,
            column: 9
          },
          end: {
            line: 369,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 365,
            column: 9
          },
          end: {
            line: 365,
            column: 22
          }
        }, {
          start: {
            line: 366,
            column: 10
          },
          end: {
            line: 368,
            column: 30
          }
        }],
        line: 365
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0, 0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0, 0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0],
      "16": [0, 0, 0],
      "17": [0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0, 0],
      "20": [0, 0, 0],
      "21": [0, 0, 0],
      "22": [0, 0],
      "23": [0, 0, 0],
      "24": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "03fb6ab466befda8148c33387b1c0f1e598f936f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_190vs8imlh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_190vs8imlh();
var Wrapper = (cov_190vs8imlh().s[0]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductLine'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)([""]))));
var LineOccurrence = (cov_190vs8imlh().s[1]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductLine-Occurrence'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  border-width: ", " 0 0 0;\n  border-style: solid;\n  border-color: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 6rem;\n  padding: 0 ", " 0 ", ";\n  ", "\n  font-size:", ";\n\n  ", ";\n"])), _stylingConstants.default.border.widthBase, function (props) {
  cov_190vs8imlh().f[0]++;
  cov_190vs8imlh().s[2]++;
  return (cov_190vs8imlh().b[0][0]++, props) && (cov_190vs8imlh().b[0][1]++, props.theme) && (cov_190vs8imlh().b[0][2]++, props.theme.collapsiblePanel) && (cov_190vs8imlh().b[0][3]++, props.theme.collapsiblePanel.borderColor) || (cov_190vs8imlh().b[0][4]++, '#E6E6E6');
}, _stylingConstants.default.spacing.medium, _stylingConstants.default.spacing.large, function (props) {
  cov_190vs8imlh().f[1]++;
  cov_190vs8imlh().s[3]++;
  return (cov_190vs8imlh().b[1][0]++, props.includeImage) && (cov_190vs8imlh().b[1][1]++, "padding-left: calc(100px + 1.5rem);");
}, _stylingConstants.default.font.sizeMS, _stylingConstants.default.mediaQueries.tablet(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    padding: 0 ", ";\n    font-size:", ";\n  "])), _stylingConstants.default.spacing.xlarge, _stylingConstants.default.font.sizeM)));
var CellWrapper = (cov_190vs8imlh().s[4]++, _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: ", ";\n  flex: 1;\n  order: 2;\n  ", ";\n"])), _stylingConstants.default.spacing.medium, _stylingConstants.default.mediaQueries.tablet(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      flex:1;\n  "])))));
var LinkWrapper = (cov_190vs8imlh().s[5]++, _styledComponents.default.a.attrs({
  className: 'stx-ProductLine-Link'
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  text-decoration: none;\n  color: inherit;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  &:hover {\n    content: '';\n    background: ", ";\n\n    opacity: 0.2;\n    cursor: pointer;\n  }\n"])), _stylingConstants.default.color.disabledText));
var OccurrenceDate = (cov_190vs8imlh().s[6]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductLine-Date'
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  order: 2;\n  .stx-ProductDate {\n    margin: 0;\n    display: flex;\n  }\n  div {\n    justify-content: left;\n    line-height: 1rem;\n    display: inline-block;\n    vertical-align: top;\n    span {\n      vertical-align: top;\n    }\n"]))));
var AvailabilityRibbon = (cov_190vs8imlh().s[7]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductLine-AvailabilityRibbon'
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  position: absolute;\n  width: ", ";\n  height: 100%;\n  top: 0;\n  left: 0;\n"])), function (props) {
  cov_190vs8imlh().f[2]++;
  cov_190vs8imlh().s[8]++;
  return _stylingConstants.default.color[props.availability];
}, _stylingConstants.default.spacing.medium));
var ImageWrapper = (cov_190vs8imlh().s[9]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-Picture'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  flex: 0 0 100px;\n  margin-left: 0;\n  position: absolute;\n  top: 0;\n  left: 1rem;\n  height: 100%;\n  width: 100px;\n  font-size: ", ";\n\n  ", ";\n"])), _stylingConstants.default.font.sizeMS, _stylingConstants.default.mediaQueries.tablet(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n    position:relative;\n    left:0;\n    margin-right: ", ";\n    margin-left: -", ";\n    font-size:", ";\n  "])), _stylingConstants.default.spacing.medium, _stylingConstants.default.spacing.medium, _stylingConstants.default.font.sizeM)));
var OccurrenceName = (cov_190vs8imlh().s[10]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-Name'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: ", ";\n  font-weight: ", ";\n  order: 1;\n  flex: 1 0 100%;\n  padding: 0.3rem 0;\n  font-size: ", ";\n\n  ", ";\n  ", ";\n"])), _stylingConstants.default.font.sizeM, _stylingConstants.default.font.weightBold, _stylingConstants.default.font.sizeMS, _stylingConstants.default.mediaQueries.tablet(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n    flex:1;\n    order:2;\n    padding:0;\n    margin-right: ", ";\n    font-size:", ";\n\n  "])), _stylingConstants.default.spacing.medium, _stylingConstants.default.font.sizeM), _stylingConstants.default.mediaQueries.desktop(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n    "])))));
var OccurrencePrice = (cov_190vs8imlh().s[11]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-Price'
})(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  flex: 1 0 45%;\n  font-size: ", ";\n\n  ", ";\n"])), _stylingConstants.default.font.sizeMS, _stylingConstants.default.mediaQueries.tablet(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n    flex:1;\n    margin-right: ", ";\n    font-size:", ";\n\n  "])), _stylingConstants.default.spacing.medium, _stylingConstants.default.font.sizeM)));
var OccurrenceVenue = (cov_190vs8imlh().s[12]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-Venue'
})(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n  flex:1 0 45%;\n  margin-right:0;\n  font-size:", ";\n  text-align:right;\n\n  ", ";\n  &:after {\n    content: '", "';\n    margin-left:", ";\n    font-size: ", ";\n\n    ", ";\n  }\n"])), _stylingConstants.default.font.sizeMS, _stylingConstants.default.mediaQueries.tablet(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n    flex:1;\n    margin-right: ", ";\n    font-size:", ";\n    text-align:left;\n  "])), _stylingConstants.default.spacing.medium, _stylingConstants.default.font.sizeM), function (props) {
  cov_190vs8imlh().f[3]++;
  cov_190vs8imlh().s[13]++;
  return props.venue;
}, _stylingConstants.default.spacing.small, _stylingConstants.default.font.sizeMS, _stylingConstants.default.mediaQueries.tablet(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: ", ";\n    "])), _stylingConstants.default.font.sizeM)));
var OccurrenceActions = (cov_190vs8imlh().s[14]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-Actions'
})(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2.default)(["\n  flex: 1 0 45%;\n  font-size: ", ";\n  margin-right: 0;\n  ", ";\n  & > div {\n    padding: 0;\n    a {\n      margin: 0.25rem 0;\n    }\n  }\n"])), _stylingConstants.default.font.sizeMS, _stylingConstants.default.mediaQueries.tablet(_templateObject20 || (_templateObject20 = (0, _taggedTemplateLiteral2.default)(["\n    flex:1;\n    margin-right: ", ";\n    font-size:", ";\n\n  "])), _stylingConstants.default.spacing.medium, _stylingConstants.default.font.sizeM)));
var ColumnWrapper = (cov_190vs8imlh().s[15]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-ColumnWrapper'
})(_templateObject21 || (_templateObject21 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  flex: 1 0 45%;\n  ", ";\n"])), _stylingConstants.default.mediaQueries.tablet(_templateObject22 || (_templateObject22 = (0, _taggedTemplateLiteral2.default)(["flex:1;"])))));
var OccurrenceAdvantages = (cov_190vs8imlh().s[16]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-Advantages'
})(_templateObject23 || (_templateObject23 = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  color: ", ";\n  margin-right: auto;\n  margin-bottom: ", ";\n  padding: ", ";\n  font-size: ", ";\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  ", ";\n  ", ";\n"])), function (props) {
  cov_190vs8imlh().f[4]++;
  cov_190vs8imlh().s[17]++;
  return (cov_190vs8imlh().b[2][0]++, props.theme) && (cov_190vs8imlh().b[2][1]++, props.theme.advantage) && (cov_190vs8imlh().b[2][2]++, props.theme.advantage.backgroundColor) || (cov_190vs8imlh().b[2][3]++, _stylingConstants.default.color.positive);
}, function (props) {
  cov_190vs8imlh().f[5]++;
  cov_190vs8imlh().s[18]++;
  return (cov_190vs8imlh().b[3][0]++, props.theme) && (cov_190vs8imlh().b[3][1]++, props.theme.advantage) && (cov_190vs8imlh().b[3][2]++, props.theme.advantage.textColor) || (cov_190vs8imlh().b[3][3]++, _stylingConstants.default.color.baseBackground);
}, _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.xsmall, _stylingConstants.default.font.sizeMS, _stylingConstants.default.border.radiusSmall, function (props) {
  cov_190vs8imlh().f[6]++;
  cov_190vs8imlh().s[19]++;
  return (cov_190vs8imlh().b[4][0]++, props.includeImage) && (cov_190vs8imlh().b[4][1]++, "\n    position: absolute;\n    top: 4px;\n    left: calc(1rem + 4px);\n    font-size: ".concat(_stylingConstants.default.font.sizeXs, ";\n    text-align:").concat(props.alignResponsive, ";\n  "));
}, function (props) {
  cov_190vs8imlh().f[7]++;
  cov_190vs8imlh().s[20]++;
  return (cov_190vs8imlh().b[5][0]++, props.includeImage) && (cov_190vs8imlh().b[5][1]++, _stylingConstants.default.mediaQueries.tablet(_templateObject24 || (_templateObject24 = (0, _taggedTemplateLiteral2.default)(["\n      text-align:", ";\n  "])), props.align));
}));
var OccurrenceSoldOut = (cov_190vs8imlh().s[21]++, (0, _styledComponents.default)(CellWrapper).attrs({
  className: 'stx-ProductLine-SoldOut'
})(_templateObject25 || (_templateObject25 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  margin-top: ", ";\n  font-size: ", ";\n\n  text-align: ", ";\n  &:before {\n    content: '';\n    width: 11px;\n    height: 11px;\n    border-radius: 6px;\n    background: ", ";\n    float: left;\n    margin-top: 5px;\n    margin-right: 4px;\n  }\n"])), _stylingConstants.default.color.negative, _stylingConstants.default.spacing.xxsmall, _stylingConstants.default.font.sizeMS, function (props) {
  cov_190vs8imlh().f[8]++;
  cov_190vs8imlh().s[22]++;
  return props.align;
}, _stylingConstants.default.color.negative));

/**
 * Use this component to display a table showing the product occurrences
 * according a product id and a date range
 */
cov_190vs8imlh().s[23]++;
var ProductLine2 = function ProductLine2(_ref) {
  var props = (0, _assign.default)({}, ((0, _objectDestructuringEmpty2.default)(_ref), _ref));
  cov_190vs8imlh().f[9]++;
  var _ref2 = (cov_190vs8imlh().s[24]++, props),
    product = _ref2.product,
    performance = _ref2.performance,
    timeslot = _ref2.timeslot,
    longDateFormat = _ref2.longDateFormat,
    currencyCode = _ref2.currencyCode,
    showAvailability = _ref2.showAvailability,
    showPicture = _ref2.showPicture,
    showName = _ref2.showName,
    showDatetime = _ref2.showDatetime,
    showVenue = _ref2.showVenue,
    showActionBtn = _ref2.showActionBtn,
    showPrice = _ref2.showPrice,
    showAdvantage = _ref2.showAdvantage,
    showSoldOut = _ref2.showSoldOut,
    className = _ref2.className;
  var occurrence = (cov_190vs8imlh().s[25]++, (cov_190vs8imlh().b[6][0]++, performance) || (cov_190vs8imlh().b[6][1]++, timeslot));
  var availability = (cov_190vs8imlh().s[26]++, (cov_190vs8imlh().b[7][0]++, performance) && (cov_190vs8imlh().b[7][1]++, performance.availability) || (cov_190vs8imlh().b[7][2]++, timeslot) && (cov_190vs8imlh().b[7][3]++, timeslot.availability));
  var hasAdvantages;
  cov_190vs8imlh().s[27]++;
  if (performance) {
    cov_190vs8imlh().b[8][0]++;
    cov_190vs8imlh().s[28]++;
    hasAdvantages = performance.withAdvantage;
  } else {
    cov_190vs8imlh().b[8][1]++;
    cov_190vs8imlh().s[29]++;
    if (timeslot) {
      cov_190vs8imlh().b[9][0]++;
      cov_190vs8imlh().s[30]++;
      hasAdvantages = timeslot.withAdvantage;
    } else {
      cov_190vs8imlh().b[9][1]++;
    }
  }
  var _ref3 = (cov_190vs8imlh().s[31]++, (cov_190vs8imlh().b[10][0]++, performance) || (cov_190vs8imlh().b[10][1]++, timeslot)),
    notOnSales = _ref3.notOnSales;
  var isSoldOut = (cov_190vs8imlh().s[32]++, (cov_190vs8imlh().b[11][0]++, availability === 'NONE') && (cov_190vs8imlh().b[11][1]++, !notOnSales));
  var actionBuy = (cov_190vs8imlh().s[33]++, (cov_190vs8imlh().b[12][0]++, performance) && (cov_190vs8imlh().b[12][1]++, performance.action) && (cov_190vs8imlh().b[12][2]++, performance.action.buy) || (cov_190vs8imlh().b[12][3]++, timeslot) && (cov_190vs8imlh().b[12][4]++, timeslot.action) && (cov_190vs8imlh().b[12][5]++, timeslot.action.buy));
  cov_190vs8imlh().s[34]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 304,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(LineOccurrence, {
    key: occurrence.id,
    includeImage: (cov_190vs8imlh().b[13][0]++, showPicture) && (cov_190vs8imlh().b[13][1]++, occurrence.image),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 305,
      columnNumber: 7
    }
  }, (cov_190vs8imlh().b[14][0]++, actionBuy) && (cov_190vs8imlh().b[14][1]++, /*#__PURE__*/_react.default.createElement(LinkWrapper, {
    href: actionBuy,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 306,
      columnNumber: 23
    }
  })), (cov_190vs8imlh().b[15][0]++, showAvailability) && (cov_190vs8imlh().b[15][1]++, occurrence.availability) && (cov_190vs8imlh().b[15][2]++, /*#__PURE__*/_react.default.createElement(AvailabilityRibbon, {
    availability: occurrence.availability,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 308,
      columnNumber: 38
    }
  })), (cov_190vs8imlh().b[16][0]++, showPicture) && (cov_190vs8imlh().b[16][1]++, occurrence.image) && (cov_190vs8imlh().b[16][2]++, /*#__PURE__*/_react.default.createElement(ImageWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 312,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
    performance: occurrence,
    product: product,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 313,
      columnNumber: 15
    }
  }))), /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 317,
      columnNumber: 9
    }
  }, (cov_190vs8imlh().b[17][0]++, showAdvantage) && (cov_190vs8imlh().b[17][1]++, occurrence.withAdvantage) && (cov_190vs8imlh().b[17][2]++, hasAdvantages) && (cov_190vs8imlh().b[17][3]++, /*#__PURE__*/_react.default.createElement(OccurrenceAdvantages, {
    includeImage: (cov_190vs8imlh().b[18][0]++, showAdvantage) && (cov_190vs8imlh().b[18][1]++, occurrence.image),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 321,
      columnNumber: 15
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    size: "16",
    iconName: "grade",
    iconColor: "#FFFFFF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 322,
      columnNumber: 17
    }
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.advantageText",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 323,
      columnNumber: 17
    }
  }))), (cov_190vs8imlh().b[19][0]++, showDatetime) && (cov_190vs8imlh().b[19][1]++, occurrence.start) && (cov_190vs8imlh().b[19][2]++, /*#__PURE__*/_react.default.createElement(OccurrenceDate, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 329,
      columnNumber: 15
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductDate.default, {
    product: product,
    performance: performance,
    showDate: longDateFormat,
    showTimeTo: longDateFormat,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 330,
      columnNumber: 17
    }
  })))), (cov_190vs8imlh().b[20][0]++, showName) && (cov_190vs8imlh().b[20][1]++, occurrence.name) && (cov_190vs8imlh().b[20][2]++, /*#__PURE__*/_react.default.createElement(OccurrenceName, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 339,
      columnNumber: 41
    }
  }, occurrence.name)), (cov_190vs8imlh().b[21][0]++, showVenue) && (cov_190vs8imlh().b[21][1]++, occurrence.venue) && (cov_190vs8imlh().b[21][2]++, /*#__PURE__*/_react.default.createElement(OccurrenceVenue, {
    venue: occurrence.venue,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 343,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    iconName: "map",
    iconColor: _stylingConstants.default.color.baseSubTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 344,
      columnNumber: 15
    }
  }))), /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 347,
      columnNumber: 9
    }
  }, (cov_190vs8imlh().b[22][0]++, showPrice) && (cov_190vs8imlh().b[22][1]++, /*#__PURE__*/_react.default.createElement(OccurrencePrice, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 349,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_price.default, {
    currencyCode: currencyCode,
    minAmount: occurrence.minAmount,
    maxAmount: occurrence.maxAmount,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 350,
      columnNumber: 15
    }
  }))), (cov_190vs8imlh().b[23][0]++, showSoldOut) && (cov_190vs8imlh().b[23][1]++, isSoldOut) && (cov_190vs8imlh().b[23][2]++, /*#__PURE__*/_react.default.createElement(OccurrenceSoldOut, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 359,
      columnNumber: 15
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.soldOutText",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 360,
      columnNumber: 17
    }
  })))), (cov_190vs8imlh().b[24][0]++, showActionBtn) && (cov_190vs8imlh().b[24][1]++, /*#__PURE__*/_react.default.createElement(OccurrenceActions, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 366,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
    performance: occurrence,
    product: product,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 367,
      columnNumber: 13
    }
  })))));
};
cov_190vs8imlh().s[35]++;
ProductLine2.propTypes = {
  /**
   * Product specified by id
   */
  product: _product.ProductType.isRequired,
  /**
   * Performance for a product ID
   */
  performance: _product.PerformanceType,
  /**
   * Timeslot for a product ID
   */
  timeslot: _product.TimeslotType,
  /**
   * Indicate if the show the long date format
   */
  longDateFormat: _propTypes.default.bool,
  /**
   *  Currency code to display correctly the price
   */
  currencyCode: _propTypes.default.string.isRequired,
  /**
   * Boolean to show Availability
   */
  showAvailability: _propTypes.default.bool,
  /**
   * Boolean to show  Picture
   */
  showPicture: _propTypes.default.bool,
  /**
   * Boolean to show  Name
   */
  showName: _propTypes.default.bool,
  /**
   * Boolean to show  Date time
   */
  showDatetime: _propTypes.default.bool,
  /**
   * Boolean to show  Advantage
   */
  showAdvantage: _propTypes.default.bool,
  /**
   * Boolean to show  Venue
   */
  showVenue: _propTypes.default.bool,
  /**
   * Boolean to show  Action buttons
   */
  showActionBtn: _propTypes.default.bool,
  /**
   * Boolean to show  Price
   */
  showPrice: _propTypes.default.bool,
  /**
   * Boolean to show  Sold Out
   */
  showSoldOut: _propTypes.default.bool,
  /**
   * Value of the className for the row
   */
  className: _propTypes.default.string
};
cov_190vs8imlh().s[36]++;
ProductLine2.defaultProps = {
  performance: null,
  timeslot: null,
  longDateFormat: true,
  showAvailability: true,
  showPicture: true,
  showDatetime: true,
  showAdvantage: true,
  showName: true,
  showVenue: true,
  showPrice: true,
  showSoldOut: true,
  showActionBtn: true,
  className: ''
};
var _default = exports.default = ProductLine2;